var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMagnet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.116 6.401l-6.922 6.922a1.713 1.713 0 01-1.22.505c-.46 0-.893-.18-1.219-.505a1.714 1.714 0 01-.505-1.22c0-.46.18-.893.505-1.219l6.926-6.926L9.821.126l-.545.437c-.415.333-.831.666-1.244.995C5.86 3.293 3.808 4.931 2.34 6.38l-.004.004A7.924 7.924 0 000 12.024c0 2.13.83 4.133 2.336 5.64A7.924 7.924 0 007.976 20a7.923 7.923 0 005.628-2.324c1.64-1.503 3.16-3.464 4.77-5.54.362-.466.736-.948 1.107-1.418l.431-.547-3.796-3.77zM9.007 2.779l.703-.561 1.757 1.744-1.082 1.083L8.506 3.18l.501-.4zm3.53 13.756l-.026.024a6.371 6.371 0 01-4.535 1.878 6.371 6.371 0 01-4.535-1.878 6.371 6.371 0 01-1.878-4.535c0-1.713.666-3.322 1.876-4.534 1.022-1.008 2.365-2.133 3.84-3.326l2 1.986L5.65 9.78a3.265 3.265 0 00-.963 2.324c0 .878.342 1.703.963 2.324.621.62 1.447.963 2.325.963.878 0 1.703-.342 2.324-.963l3.633-3.634 1.976 1.963c-1.13 1.427-2.234 2.738-3.371 3.778zm4.603-5.356l-.263.338-1.84-1.827 1.083-1.083 1.704 1.692c-.23.295-.46.59-.684.88z",
    fill: "url(#magnet_svg__paint0_linear_6376_98362)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.006 1.387L20 .393 18.56 0l-3.776 1.372 2.144 2.145-2.58 1.01 1.143 1.144 4.048-1.643-2.085-2.084 1.552-.557z",
    fill: "url(#magnet_svg__paint1_linear_6376_98362)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "magnet_svg__paint0_linear_6376_98362",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1393BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magnet_svg__paint1_linear_6376_98362",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1393BC"
  })))));
}

export default __webpack_public_path__ + "./fonts/magnet.9e050939cc614a1026ae9dbb4c6b1cdc.svg";
export { SvgMagnet as ReactComponent };